var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"flex-column",attrs:{"align":"center"}},[_c('v-card-subtitle',{staticClass:"pb-0"},[_vm._v(_vm._s(_vm.title))]),_c('v-col',{staticClass:"pt-0"},[_c('v-row',[_vm._t("items")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }